<template>
  <svg width="20" height="19" viewBox="0 0 20 19">
    <path
      d="M10 3.238c.434 0 .786.352.786.786v4.714H15.5a.786.786 0 1 1 0 1.572h-4.715v4.714a.786.786 0 1 1-1.57 0l-.002-4.715H4.5a.786.786 0 0 1 0-1.57h4.713l.001-4.715c0-.434.352-.786.786-.786z"
      fill="#000"
      fill-rule="evenodd"
    />
  </svg>
</template>
